import React from 'react';
import ReactSelect from 'react-select';
import {MenuItem, Select} from '@material-ui/core';

import {OptionsType} from './MrssDefaultsTypes';

export interface MrssDefaultMultiSelectorProps {
    onChange: (val?: any) => void;
    value: OptionsType[];
    options?: OptionsType[];
    variant: string;
    isMulti?: boolean;
    selectorType?: string;
}

export type Option = {
    label: string;
    value: string;
};

export const mapOptions = ({value}: Option) => (
    <MenuItem key={value} value={value}>
        {value}
    </MenuItem>
);

export default function MrssDefaultMultiSelector(props: MrssDefaultMultiSelectorProps) {
    const {
        onChange,
        value,
        options = [],
        variant,
        isMulti,
        selectorType = 'react',
    } = props;

    if (selectorType === 'react') {
        return (
            <ReactSelect
                className="select-overwrite"
                onChange={onChange}
                value={value}
                closeMenuOnSelect={!isMulti}
                isMulti={isMulti}
                options={options}
                variant={variant}
            />
        );
    }

    return (
        <Select
            className="qc-metadata__editable-item"
            value={value[0]?.value || ''}
            onChange={onChange}
        >
            {options.map(mapOptions)}
        </Select>
    );
}
